import React, { useState } from 'react';
import { Container, Row, Card, Col, Form, Button, Spinner } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import { useEffect } from 'react';
import { ArrowBackIos, TrafficRounded, WidgetsOutlined } from '@material-ui/icons';
import ProviderRequestService from 'services/provider-request';
import { Link } from 'react-router-dom';
import Can from 'components/Can';
import UnauthorizedAccess from 'components/Error/UnauthorizedAccess';
import { useParams } from 'react-router-dom';
import { OpenInNew } from '@material-ui/icons';
import BootstrapTable from 'react-bootstrap-table-next';

export default function(){
  const [currentCompany] = useState(JSON.parse(localStorage.getItem('currentCompany')));

  const { id } = useParams();
  const [provider, setProvider] = useState({});
  const [logoPreview, setLogoPreview] = useState(null);

  const [documents, setDocuments] = useState([]);
  const [errorAccess, setErrorAccess] = useState(false);

  const Data = [];
  const columns = [
    {
      dataField: 'key',
      text: '',
      style: {
        display: 'none',
      },
      headerStyle: {
        display: 'none',
      },
    },
    {
      dataField: 'category',
      text: 'Categoria',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'name',
      text: 'Nome',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    },
    {
      dataField: 'url_document',
      text: 'Acessar',
      headerStyle: {
        textAlign: 'center'
      },
      style: {
        textAlign: 'center'
      }
    }
  ];

  const renderData = () => {
    documents.map((item, k) => {
      Data.push({
        k: k,
        category: item.category,
        name: item.name,
        url_document: <a href={item.url_document} target="_blank"><OpenInNew /></a>
      });
    });
  }

  useEffect(() => {
    if (id) {
      ProviderRequestService.show(id, {
        params: {
          __company_id: currentCompany ? currentCompany.id : null
        }
      }).then(data => {
        setLogoPreview(
          data.data.url_image_logo
            ? data.data.url_image_logo
            : null
        );
        setProvider(data.data);
      }).catch(error => {
        if (error.response.status === 403 && error.response.data.message === "unauthorized access") {
          setErrorAccess(true);
        }
      });
      ProviderRequestService.getDocument(id).then(data => {
        setDocuments(data.data.map(a => {
          return {
            id: a.id,
            category: a.categories.name,
            name: a.name,
            url_document: a.url_document,
            document_name: a.document_name,
          }
        }))
      });
    }
  }, [id])

  if (errorAccess) {
    return <UnauthorizedAccess />
  }

  renderData();
  return (
    <>
      <Container className="mb-5">
        <Row className="mt-4 justify-content-between">
          <Link to="/master-agent/providers" className="link-back">
            <Col className="row">
              <ArrowBackIos className="icon-title icon-back" />
              <h6 className="font-13 mt-3 w-auto">Voltar</h6>
            </Col>
          </Link>
        </Row>
        <Row className="col-12 mt-4 row">
          <WidgetsOutlined className="icon-title" />
          <h5 className="title-dashboard">Fornecedor - {provider.name}</h5>
        </Row>
        <Row>
          <Col className="col-12 d-flex justify-content-center my-3">
            <Card.Body className="shadow bg-white rounded pt-3">
              <Can do="providers.edit" on="App">
                <Col xs="auto" className="float-right">
                  <Link to={"/master-agent/provider/edit/" + id} className="link-back">
                    <Button>Editar</Button>
                  </Link>
                </Col>
              </Can>
              <Row>
                <Col>
                  <img src={logoPreview} width="250" />
                </Col>
              </Row>
              <Row className="mt-4">
                <Col className="p-0">
                  <BootstrapTable  style={{ width: '100px' }}
                    id="table"
                    className="font-10"
                    keyField="id"
                    data={Data}
                    columns={columns}
                    bordered={false}
                    hover
                    condensed
                  />
                </Col>
              </Row>
            </Card.Body>
          </Col>
        </Row>
      </Container>
    </>
  );
}